import Entity from '../entity'
export default class CallCenter extends Entity<number>{
    nombre: string;
    path: string;
}